import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { lazyRouteNamed } from '../lazy-route';

export const authRoutes: RouteObject[] = [
  {
    path: RoutesList.PROFILE,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(() => import('../../pages/profile/profile-page'), 'ProfilePage'),
      },
      {
        path: 'change-password',
        ...lazyRouteNamed(
          () => import('../../pages/profile/change-password-page'),
          'ChangePasswordPage',
        ),
      },
    ],
  },
];
